// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.MappingErrorTree.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIO

import React, { Component } from 'react';
import TreeView from 'share/components/controls/Izenda.TreeView';
import PropTypes from 'prop-types';
import { uniqueId, split, findIndex } from 'lodash/fp';
import connect from 'share/enhancers/Izenda.Connect';

@connect()
export default class MappingErrorTree extends Component {
  static propTypes = {
    errorMessages: PropTypes.array
  };

  /**
   * @param {Object} node
   * @returns {Array}
   */
  getChildNodes = (node: any): Array<any> => {
    if (node.report) return node.errors;
    if (node.dashboard) return node.dashboard.reports;
    return [];
  };

  /**
   * Render error messages
   * @param {Object} node
   */
  renderErrorMessage(node: any): any {
    const fieldStart = node.indexOf('[');
    const fieldEnd = node.indexOf(']');

    const field = node.substring(fieldStart + 1, fieldEnd);
    const type = node.substring(0, fieldStart);
    const others = node.substring(fieldEnd + 2);

    return (
      <label className="u_marginLeftInnerSpace">
        {type}
        <span>
          <strong className="u_marginRightInnerSpace">{field}</strong>
          {others}
        </span>
      </label>
    );
  }

  /**
   * Render error messages
   * @param {Object} node
   * @param {Object} toggleIcon
   */
  renderErrorLocation(node: any, toggleIcon: any) {
    const { localization } = this.props;

    const textError = node.report
      ? `${localization.getText('CONTEXT_MENU_LABEL_REPORT')}: ${node.report}`
      : `${localization.getText('CONTEXT_MENU_LABEL_DASHBOARD')}: ${node.dashboard.dashboard}`;

    return (
      <div>
        {toggleIcon}
        <label className="u_marginLeftInnerSpace">{textError}</label>
      </div>
    );
  }

  renderNode = (node: any, toggleIcon: any) => {
    if (!node.report && !node.dashboard) {
      return this.renderErrorMessage(node);
    }
    return this.renderErrorLocation(node, toggleIcon);
  };

  /**
   * Set node always expands
   * @returns {boolean}
   */
  nodeExpand = (): boolean => {
    return true;
  };

  /**
   * Create uniqueId for node
   * @returns {string}
   */
  getKey = (): string => {
    return uniqueId('MappingErrorTree_');
  };

  render() {
    const { errorMessages } = this.props;

    return (
      <div className="u_fullSize u_borderAll izenda-MappingError-tree">
        <TreeView
          collapsed={false}
          nodes={errorMessages}
          getKey={this.getKey}
          renderNode={this.renderNode}
          getChildNodes={this.getChildNodes}
          nodeExpand={this.nodeExpand}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/Import/Popup/Izenda.MappingErrorTree.js